import { render, staticRenderFns } from "./_base-serverSyncDataTable.vue?vue&type=template&id=fe040716&scoped=true"
import script from "./_base-serverSyncDataTable.vue?vue&type=script&lang=js"
export * from "./_base-serverSyncDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe040716",
  null
  
)

export default component.exports